import { WebPlugin } from '@capacitor/core';
export class HeadsetPluginWeb extends WebPlugin {
    setAudioMode(options) {
        throw new Error('Not implemented on web: ' + options.audioMode);
    }
    toggleBluetoothSco(options) {
        throw new Error('Not implemented on web: ' + options.scoOn);
    }
    toggleSpeakerphone(options) {
        throw new Error('Not implemented on web: ' + options.speakerphoneOn);
    }
    getOutputDevices() {
        throw new Error('Not implemented on web.');
    }
    getAudioMode() {
        throw new Error('Not implemented on web.');
    }
    isSpeakerphoneOn() {
        throw new Error('Not implemented on web.');
    }
    isBluetoothScoOn() {
        throw new Error('Not implemented on web.');
    }
    hasBuiltInEarpiece() {
        throw new Error('Not implemented on web.');
    }
    hasBuiltInSpeaker() {
        throw new Error('Not implemented on web.');
    }
    async checkPermissions() {
        throw this.unimplemented('Not implemented on web.');
    }
    async requestPermissions() {
        throw this.unimplemented('Not implemented on web.');
    }
    async start(options) {
        throw this.unimplemented('Not implemented on web. ' + options.type);
    }
    async stop() {
        throw this.unimplemented('Not implemented on web.');
    }
    async setActive(options) {
        throw this.unimplemented('Not implemented on web.' + options.isActive);
    }
}
//# sourceMappingURL=web.js.map